import { useCallback, useRef, useState } from 'react';

import { Platform } from 'react-native';

import { isWeb } from 'utils/responsiveness';

function useScrollOffset() {
    const [webScrollOffset, setWebScrollOffset] = useState(0);
    const mobileScrollOffset = useRef(0);

    const handleSetScrollOffset = useCallback((offset) => {
        if (isWeb) {
            setWebScrollOffset(offset);
        } else {
            mobileScrollOffset.current = offset;
        }
    }, []);

    return {
        scrollOffset: Platform.select({
            web: webScrollOffset,
            default: mobileScrollOffset.current,
        }),
        handleSetScrollOffset,
    };
}

export default useScrollOffset;
